@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.fcm

import com.narbase.letsgo.router.EndPoint

object UpdatePassengerVoipTokenEndpoint :
    EndPoint<UpdatePassengerVoipTokenEndpoint.Request, UpdatePassengerVoipTokenEndpoint.Response>() {
    class Request(
        val voipToken: String
    )

    class Response
}